// src/hooks/useTwoFAStatus.ts
import { useQuery } from '@tanstack/react-query'
import type { AxiosResponse } from 'axios'
import { getCurrentUser } from '../services/userService'

export interface TwoFAStatus {
    is2faEnabled: boolean
    isLineUser: boolean
}

export const useTwoFAStatus = () => {
    return useQuery<TwoFAStatus, Error>({
        queryKey: ['currentUser'],
        queryFn: async (): Promise<TwoFAStatus> => {
            const res: AxiosResponse = await getCurrentUser()
            return {
                is2faEnabled: res.data.is_2fa_enabled,
                isLineUser: !!res.data.line_social_id,
            }
        },
        staleTime: 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
    })
}
